"use client";
import { useState } from "react";
import { Check, Copy } from "lucide-react";

/** Copies a guide's example to the clipboard. Rendered next to each code block; without JavaScript the
 * code is still selectable, so this is an enhancement only. */
export function CopyCodeButton({ text, label, done }: { text: string; label: string; done: string }) {
  const [copied, setCopied] = useState(false);
  return <button type="button" className="vc-copy" aria-label={copied ? done : label} onClick={async () => {
    try { await navigator.clipboard.writeText(text); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch { /* clipboard blocked: the code stays selectable */ }
  }}>{copied ? <Check size={14} aria-hidden /> : <Copy size={14} aria-hidden />}<span aria-live="polite">{copied ? done : label}</span></button>;
}
